import { render } from "./DefaultCoverOption.vue?vue&type=template&id=3254bede"
import script from "./DefaultCoverOption.vue?vue&type=script&lang=js"
export * from "./DefaultCoverOption.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__